// Search + Select All for the Size/Colour layered-nav checkbox lists in
// sidebar-shop-filters.php, plus navigation for every .fw-toggle-link-checkbox
// (layered-nav terms and the standalone Availability toggle).

( function ( $ ) {
	'use strict';

	// Ticking several checkboxes quickly all navigate on their own `change`
	// event -- the first click's navigation would unload the page before a
	// second click even registers, so only one selection would ever survive.
	// Debounce the actual navigation, resetting the timer on every further
	// change, so a burst of clicks collapses into a single navigation once
	// the user pauses.
	var NAVIGATE_DELAY_MS = 600;
	var navigateTimer = null;

	function scheduleNavigate( url ) {
		clearTimeout( navigateTimer );
		navigateTimer = setTimeout( function () {
			window.location.href = url;
		}, NAVIGATE_DELAY_MS );
	}

	function attributeParamName( taxonomy ) {
		// pa_size -> size, pa_color -> color (matches wc_attribute_taxonomy_slug()).
		return taxonomy.replace( /^pa_/, '' );
	}

	function rows( $container ) {
		return $container.find( '.woocommerce-widget-layered-nav-list__item' );
	}

	function visibleRows( $container ) {
		return rows( $container ).filter( ':visible' );
	}

	function updateSelectAllState( $container ) {
		var $visible = visibleRows( $container );
		var $selectAll = $container.find( '.fw-select-all-checkbox' );

		if ( ! $visible.length ) {
			$selectAll.prop( 'checked', false );
			return;
		}

		var allChecked = $visible.toArray().every( function ( row ) {
			return $( row ).find( '.fw-toggle-link-checkbox' ).prop( 'checked' );
		} );

		$selectAll.prop( 'checked', allChecked );
	}

	function filterRows( $container, term ) {
		var needle = term.trim().toLowerCase();

		rows( $container ).each( function () {
			var $row = $( this );
			var label = $row.find( '.form-check-label' ).text().toLowerCase();
			$row.toggle( ! needle || -1 !== label.indexOf( needle ) );
		} );

		updateSelectAllState( $container );
	}

	function buildFilterUrl( taxonomy, slugs ) {
		var param = 'filter_' + attributeParamName( taxonomy );
		var queryTypeParam = 'query_type_' + attributeParamName( taxonomy );
		var url = new URL( window.location.href );

		if ( slugs.length ) {
			url.searchParams.set( param, slugs.join( ',' ) );
			url.searchParams.set( queryTypeParam, 'or' );
		} else {
			url.searchParams.delete( param );
			url.searchParams.delete( queryTypeParam );
		}

		return url.toString();
	}

	function checkedSlugs( $container ) {
		return rows( $container )
			.find( '.fw-toggle-link-checkbox' )
			.toArray()
			.filter( function ( input ) {
				return input.checked;
			} )
			.map( function ( input ) {
				return input.getAttribute( 'data-slug' );
			} );
	}

	$( document ).on( 'input', '.fw-filterable-list .fw-filter-search', function () {
		filterRows( $( this ).closest( '.fw-filterable-list' ), $( this ).val() );
	} );

	$( document ).on( 'change', '.fw-filterable-list .fw-select-all-checkbox', function () {
		var $container = $( this ).closest( '.fw-filterable-list' );
		var taxonomy = $container.data( 'filter-taxonomy' );
		var checked = $( this ).prop( 'checked' );
		var slugs = checked
			? visibleRows( $container ).find( '.fw-toggle-link-checkbox' ).toArray().map( function ( input ) {
				return input.getAttribute( 'data-slug' );
			} )
			: [];

		scheduleNavigate( buildFilterUrl( taxonomy, slugs ) );
	} );

	// Individual layered-nav term checkboxes (Size/Colour) -- rebuild the URL
	// from every currently-checked box in this group, not just the one that
	// just changed, so a quick burst of clicks ends up selecting all of them
	// once the debounced navigation actually fires.
	$( document ).on( 'change', '.fw-filterable-list .fw-toggle-link-checkbox', function () {
		var $container = $( this ).closest( '.fw-filterable-list' );
		var taxonomy = $container.data( 'filter-taxonomy' );

		scheduleNavigate( buildFilterUrl( taxonomy, checkedSlugs( $container ) ) );
	} );

	// Standalone single toggles outside any .fw-filterable-list (currently
	// just Availability's in-stock checkbox) -- data-href is already the
	// complete destination, nothing to rebuild, just debounced like the rest.
	$( document ).on( 'change', '.fw-toggle-link-checkbox', function () {
		if ( $( this ).closest( '.fw-filterable-list' ).length ) {
			return;
		}

		var href = $( this ).data( 'href' );
		if ( href ) {
			scheduleNavigate( href );
		}
	} );

	$( function () {
		$( '.fw-filterable-list' ).each( function () {
			updateSelectAllState( $( this ) );
		} );
	} );

	// The Price filter widget is rendered exactly once (WooCommerce's own
	// price-slider.js reads #min_price/#max_price via un-namespaced
	// selectors, so a second render would silently corrupt the other
	// instance rather than just risk a duplicate-ID warning). Physically
	// move that single node into whichever of the desktop dropdown / mobile
	// offcanvas is currently relevant, rather than rendering it twice.
	$( document ).on( 'show.bs.offcanvas', '#fw-filter-offcanvas', function () {
		var $mount = $( '#fw-price-filter-mount' );
		var $target = $( '#fw-price-filter-mobile-target' );
		if ( $mount.length && $target.length ) {
			$target.append( $mount );
		}
	} );

	$( document ).on( 'hidden.bs.offcanvas', '#fw-filter-offcanvas', function () {
		var $mount = $( '#fw-price-filter-mount' );
		var $target = $( '#fw-price-filter-desktop-target' );
		if ( $mount.length && $target.length ) {
			$target.append( $mount );
		}
	} );
} )( jQuery );
